export const formattedPercentage = (value: number | undefined, addPlusSign = false) => {
  if (value === undefined || isNaN(value)) {
    return 'n.A.';
  }
  const formattedValue = Number(value).toFixed(0) + '%';
  return addPlusSign && value > 0 ? `+${formattedValue}` : formattedValue;
};
